import React, { Component} from 'react';
import { connect } from 'react-redux';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import { styled, useTheme } from '@mui/material/styles';
import Grid from '@material-ui/core/Grid'
import Info from '@material-ui/icons/Info';
import Help from '@material-ui/icons/Help';
import Popover from '@material-ui/core/Popover';

import {InfoPopover, WelcomeDialog} from './Dialogs';

import Toolbar from '@mui/material/Toolbar';
import MuiAppBar from '@mui/material/AppBar';
import CssBaseline from '@mui/material/CssBaseline';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';



//-----------------------------------------------------------------



const useStyles = (theme) => ({
    
  

});
const drawerWidth = 240;

const AppBar2 = styled(MuiAppBar, {
  shouldForwardProp: (prop) => prop !== 'open',
})(({ theme, open }) => ({
  zIndex: theme.zIndex.drawer + 1,
  transition: theme.transitions.create(['width', 'margin'], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  ...(true && {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  }),
}));


//-----------------------------------------------------------------



class TitleBar_ extends Component {

  constructor(props) {
    super(props);

    this.state = {
      showPopoverInfo: false,
      anchorEl: null,
    };

  }



  render() {

    const styles = {
       
      buttonAccount: {
        margin: 4,
        borderRadius:64,
      },

      imageWZL: {
        width: 180, 
        height: 42,
        marginTop: 0,
      }

    };

    const {classes} = this.props;
    

    return (
      <div>
        <CssBaseline />
        <AppBar position="fixed">
          <Toolbar>

            <Grid
              justify="space-between"
              container 
            >

              <Grid item>

                <Grid
                  container
                  direction="row"
                  justifyContent="center"
                  alignItems="center">

                  <Grid item>
                    <img  style={styles.imageWZL} 
                          src={"wzl.png"}/>
                  </Grid>

                  <div style={{height:32, width:1, backgroundColor:'#FFFFFFCC', margin:8, marginLeft:20, marginRight:20}}/>

                  <Grid item>
                    <Typography variant="h6">CT Parameter Simulation </Typography>
                  </Grid>
                </Grid>

              </Grid>

              <Grid item>
                  {/**<Button
                    style={styles.buttonAccount}
                    variant="contained"
                    color="secondary"
                    startIcon={<AccountCircle />}
                  >
                    {this.props.name == "Anonymous" ? "Guest" : this.props.name}
                  </Button>**/}

                  <IconButton
                    style={{marginLeft:10}}
                    aria-label="account of current user"
                    aria-controls="menu-appbar"
                    aria-haspopup="true"
                    color="inherit"
                    onClick={() => { this.props.onOpenWelcomeDialog() }}
                  >
                    <Help />
                  </IconButton>

                  <IconButton
                    style={{marginLeft:10}}
                    aria-label="account of current user"
                    aria-controls="menu-appbar"
                    aria-haspopup="true"
                    color="inherit"
                    onClick={(event) => { this.setState({showPopoverInfo: true, anchorEl:event.currentTarget}); }}
                  >
                    <Info />
                  </IconButton>

              </Grid>
      
            </Grid>

          </Toolbar>
        </AppBar>

        <Popover
            anchorEl={this.state.anchorEl}
            open={this.state.showPopoverInfo}
            onClose={() => { this.setState({showPopoverInfo: false}); }}
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'center',
            }}
            transformOrigin={{
              vertical: 'top',
              horizontal: 'center',
            }}>

            <InfoPopover/>

        </Popover>

        <WelcomeDialog/>

      </div>
    );

  }

}



//-----------------------------------------------------------------



const mapStateToProps = (state, props) => {

    if (state.user.profile != undefined) {
      let profile = state.user.profile;
      return {name: profile.firstName + " " + profile.lastName, 
              image: profile.attributes.picture };
    }

    else {
      return {name:"Anonymous", 
              image:""};
    }

}

const mapDispatchToProps = (dispatch, props) => {

    return {
      onOpenWelcomeDialog: () => { dispatch({ type: "DIALOG:WELCOME-OPEN" }) },
    };
    
}


const TitleBar = connect(mapStateToProps, mapDispatchToProps)(TitleBar_)
export default withStyles(useStyles) (TitleBar);


